import { CircularProgress, TextField } from "@mui/material";
import {
  ClearForm,
  FileInput,
  FileInputDesc,
  FileInputTitle,
  FileInputUploadIconWrapper,
  FileInputWrapper,
  GridElement,
  GridElementFullWidth
} from "../style";
import { POD_ONBOARDING } from "utility/constants";
import { customiseMaterialUITextBoxStyle } from "utility/styles";
import { MandatoryStarWrapper } from "utility/styled-components";
import { FormError, FormSuggestion } from "shared-compoents/form-components";
import UploadIcon from "assets/UploadIcon";
import { UseFormRegister } from "react-hook-form";

export const PodOnboardingStep1 = ({
  register,
  errors,
  architectureDiagramFile,
  onClickClearArchitectureFile,
  validatePodAbbreviation,
  isValidatingPod,
  podError,
  validatePodAmbassadorEmail,
  isValidatingPodAmbassadorEmail,
  podAmbassadorEmailError
}: {
  register: UseFormRegister<{
    ciName?: string | undefined;
    architectureDiagramFile?: {} | undefined;
    pod: string; description: string;
    businessVertical: string;
    podAmbassadorEmail: string;
    podFullName: string;
    is_wandb_onboarding_enabled: boolean;
  }>;
  errors: any;
  architectureDiagramFile: any;
  onClickClearArchitectureFile(event: React.MouseEvent<HTMLElement>): void;
  validatingFieldsStep1: Partial<
    Readonly<{
      architectureDiagramFile?: {} | undefined;
      ciName?: boolean | undefined;
      pod?: boolean | undefined;
      podAmbassadorEmail?: boolean | undefined;
      description?: boolean | undefined;
      businessVertical?: boolean | undefined;
      podFullName?: boolean | undefined;
      is_wandb_onboarding_enabled?: boolean | undefined;
    }>
  >;
  validatePodAbbreviation: (pod: string) => Promise<void>;
  podError: string;
  isValidatingPod: boolean;
  podAmbassadorEmailError: string;
  isValidatingPodAmbassadorEmail: boolean;
  validatePodAmbassadorEmail: (email: string) => Promise<void>
}) => {

  return (
    <>
      <GridElement>
        <TextField
          {...register("podFullName")}
          label={
            <>
              {POD_ONBOARDING.podNameLabel}{" "}
              <MandatoryStarWrapper>*</MandatoryStarWrapper>
            </>
          }
          fullWidth
          margin="normal"
          sx={customiseMaterialUITextBoxStyle}
          defaultValue=""
        ></TextField>
        <FormSuggestion>
          For example: Pod Name is Toyota Data Science Platform for tdsp Pod Abbreviation.
        </FormSuggestion>
        {errors && errors?.podFullName ? (
          <FormError>{errors?.podFullName?.message}</FormError>
        ) : (
          <></>
        )}
      </GridElement>
      <GridElement>
        <TextField
          {...register("pod", {
            onChange: (event) => {
              setTimeout(async () => await validatePodAbbreviation(event.target.value), 0)
            }
          })}
          id="pod"
          label={
            <>
              {"Pod Abbreviation"}{" "}
              <MandatoryStarWrapper>*</MandatoryStarWrapper>
            </>
          }
          fullWidth
          margin="normal"
          sx={customiseMaterialUITextBoxStyle}
          defaultValue=""
        ></TextField>
        <FormSuggestion>
          Pod name should contain only alphabets. For example: wds, bds
        </FormSuggestion>
        {isValidatingPod && (
          <FormSuggestion>
            <CircularProgress size="0.7rem" /> Validating Pod Abbreviation...
          </FormSuggestion>
        )}
        {errors &&
        errors?.pod ? (
          <FormError>{errors?.pod?.message}</FormError>
        ) : (
          <>
            {
              podError && <FormError>{ podError }</FormError>
            }
          </>
        )}
      </GridElement>
      <GridElement>
        <TextField
          {...register("podAmbassadorEmail", {
            onChange: (event) => {
              setTimeout(async () => await validatePodAmbassadorEmail(event.target.value), 0)
            } 
          })}
          id="podAmbassadorEmail"
          label={
            <>
              {POD_ONBOARDING.podAmbassadorEmail}{" "}
              <MandatoryStarWrapper>*</MandatoryStarWrapper>
            </>
          }
          fullWidth
          margin="normal"
          sx={customiseMaterialUITextBoxStyle}
          defaultValue=""
        ></TextField>
        {isValidatingPodAmbassadorEmail && (
          <FormSuggestion>
            <CircularProgress size="0.7rem" /> Validating Pod Ambassador
            Email...
          </FormSuggestion>
        )}
        {errors &&
        errors?.podAmbassadorEmail
         ? (
          <FormError>{errors?.podAmbassadorEmail.message}</FormError>
        ) : (
          <>
            {
              podAmbassadorEmailError && <FormError>{podAmbassadorEmailError}</FormError>
            }
          </>
        )}
      </GridElement>
      <GridElement>
        <TextField
          {...register("ciName")}
          label={<>{POD_ONBOARDING.ciNameLabel}</>}
          fullWidth
          margin="normal"
          sx={customiseMaterialUITextBoxStyle}
          defaultValue=""
        ></TextField>
        {errors && errors?.ciName ? (
          <FormError>{errors?.ciName.message}</FormError>
        ) : (
          <></>
        )}
      </GridElement>
      <GridElementFullWidth>
        <TextField
          {...register("businessVertical")}
          label={
            <>
              {POD_ONBOARDING.businessVertical}{" "}
              <MandatoryStarWrapper>*</MandatoryStarWrapper>
            </>
          }
          fullWidth
          margin="normal"
          sx={customiseMaterialUITextBoxStyle}
          defaultValue=""
        ></TextField>
        <FormSuggestion>
          For example: SCAFT, Manufacturing, Quality etc.
        </FormSuggestion>
        {errors && errors?.businessVertical ? (
          <FormError>{errors?.businessVertical.message}</FormError>
        ) : (
          <></>
        )}
      </GridElementFullWidth>
      <GridElementFullWidth>
        <TextField
          {...register("description")}
          label={
            <>
              {POD_ONBOARDING.projectDescription}{" "}
              <MandatoryStarWrapper>*</MandatoryStarWrapper>
            </>
          }
          fullWidth
          multiline
          rows={2}
          sx={customiseMaterialUITextBoxStyle}
        />
        {errors && errors?.description ? (
          <FormError>{errors?.description.message}</FormError>
        ) : (
          <></>
        )}
      </GridElementFullWidth>
      {/* <GridElementFullWidth>
      <TextField
        {...register("architectureDiagramLink")}
        label="Architecture Diagram Link"
        fullWidth
        sx={customiseMaterialUITextBoxStyle}
      />
      {errors && errors?.architectureDiagramLink ? (
        <FormError>
          {errors?.architectureDiagramLink.message as string}
        </FormError>
      ) : (
        <></>
      )}
    </GridElementFullWidth> */}
      <GridElementFullWidth>
        <FileInputWrapper>
          <FileInputUploadIconWrapper>
            <UploadIcon width={16} height={12} />
          </FileInputUploadIconWrapper>
          <FileInput {...register("architectureDiagramFile")} type="file" />
          <FileInputTitle>
            {architectureDiagramFile && architectureDiagramFile.length > 0
              ? `File selected "${architectureDiagramFile[0].name}"`
              : POD_ONBOARDING.UPLOAD_ARCHITECTURE}
          </FileInputTitle>
          {!(architectureDiagramFile && architectureDiagramFile.length > 0) ? (
            <FileInputDesc>
              {POD_ONBOARDING.UPLOAD_ARCHITECTURE_SUPPORTED_FORMAT}
            </FileInputDesc>
          ) : (
            <ClearForm onClick={onClickClearArchitectureFile}>Clear</ClearForm>
          )}
        </FileInputWrapper>
        {errors && errors?.architectureDiagramFile ? (
          <FormError>
            {errors?.architectureDiagramFile.message as string}
          </FormError>
        ) : (
          <></>
        )}
      </GridElementFullWidth>
    </>
  );
};

